import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    valueText: {
        fontSize: 16,
        fontWeight: '500',
    },
    trendContainer: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    trendItem: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    trendText: {
        fontSize: 14,
        fontWeight: '500',
    },
    arrow: {
        marginRight: 2,
    },
});

export const defaultColors = {
    up: '#FF3B30',       // 红色上涨
    down: '#34C759',     // 绿色下跌
    neutral: '#8E8E93',  // 灰色中性
    value: '#333333',    // 默认数值颜色
};
